import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addItems = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/method/technoerp.services.create_item',
    body
  );
  return data;
});

export const getItems = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_items?ms=1'
  );
  return data;
});
export const getServices = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_items?ms=0'
  );
  return data;
});
export const getAllServicesAndItem = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_items'
  );
  return data;
});
export const getEncounterServicesAndItem = catchAsync(async (searchTxt) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.search?type=Item&filters={"is_sales_item":1,"is_stock_item":0}&txt=${searchTxt}`
  );
  return data;
});
export const getItemGroups = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_item_groups'
  );
  return data;
});
export const getStockUoms = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_stock_uoms'
  );
  return data;
});
export const getPriceLists = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_price_lists'
  );
  return data;
});
export const deleteItems = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    `/api/method/technoerp.services.delete_record?record=${id}&document=Item`
  );
  return data;
});
